const SparkleSVG = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    viewBox='0 0 27 27'
    fill='none'
    {...props}
  >
    <path
      fill='#3D8CCC'
      d='m18.894 14.6-3.012 1.47c-1.69.82-3 2.26-3.657 4.02l-1.708 4.536a.607.607 0 0 1-.35.352.608.608 0 0 1-.777-.352l-1.705-4.537a7.312 7.312 0 0 0-3.657-4.006l-3.013-1.467a.604.604 0 0 1 0-1.086l3.013-1.466c1.692-.82 3-2.26 3.657-4.02l1.708-4.536a.63.63 0 0 1 1.127 0l1.708 4.527a7.304 7.304 0 0 0 3.654 4.022l3.012 1.464a.597.597 0 0 1 0 1.08ZM26.132 6.433l-1.112.543a2.587 2.587 0 0 0-1.293 1.416l-.628 1.677a.343.343 0 0 1-.2.197.34.34 0 0 1-.439-.197l-.63-1.677a2.58 2.58 0 0 0-1.292-1.416l-1.113-.543a.341.341 0 0 1 0-.613l1.113-.543A2.578 2.578 0 0 0 21.83 3.86l.63-1.675a.356.356 0 0 1 .162-.163.357.357 0 0 1 .477.163l.628 1.675a2.584 2.584 0 0 0 1.293 1.418l1.112.543a.34.34 0 0 1 0 .613Z'
    />
  </svg>
);
export default SparkleSVG;
